module.exports = __webpack_public_path__ + "img/AI.122602e9.png";